import './BasicSelectButton.scss';

import { IconChevronDown } from '@hulu-react-style-components/icons';
import cx from 'classnames';
import type { FC } from 'react';
import React from 'react';

import bem from '../../../../utils/bem';

const [block, element] = bem('basic-select-button');

type Props = {
  toggleOpen: () => void;
  isOpen: boolean;
  isActive?: boolean;
  text: string;
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  hideDefaultRightIcon?: boolean;
  selectButtonClassName?: string;
};

const BasicSelectButton: FC<Props> = ({
  text,
  leftIcon,
  rightIcon,
  isActive,
  isOpen,
  hideDefaultRightIcon = false,
  selectButtonClassName,
  toggleOpen,
}) => {
  const renderRightIcon: React.JSX.Element = (
    <>
      {rightIcon ??
        (!hideDefaultRightIcon && (
          <IconChevronDown width={16} height={16} className={element('chevron-icon', isOpen ? 'open' : 'closed')} />
        ))}
    </>
  );

  return (
    <button
      type="button"
      data-testid="basic-select-button"
      className={cx(selectButtonClassName ?? block(), {
        [element('active')]: isActive,
        [element('open')]: isOpen,
      })}
      onClick={toggleOpen}
    >
      {leftIcon}
      <span>{text}</span>
      {renderRightIcon}
    </button>
  );
};

export default BasicSelectButton;
